import React from "react";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

import Grid from '@mui/material/Grid';
import StdButton from './stdbutton.jsx';

class VersionForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: true,
            version: Object.assign({ id: "", displayName: "", model: "", version: "" },props.version.data),
            id: props.version.data.id
        };
        this.versionFormRef = React.createRef();
        this.setState = this.setState.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.renderBody = this.renderBody.bind(this);
        this.changeData = this.changeData.bind(this);
    }

    componentDidMount() {
    }

    static getDerivedStateFromProps(props, state) {
        if ((props.version.data.id || state.id) && props.version.data.id!=state.id) {
            var newState = {
                error: null,
                isLoaded: true,
                version: Object.assign({}, props.version.data),
                id: props.version.data.id
            };
            return newState;
        } else {
            return null;
        }
    }


    changeData(e){
        var version = this.state.version;
        version[e.target.name]=e.target.value;
        this.setState({ version: version });
    }

    handleSubmit(e) {
        e.preventDefault();
        const data = new FormData(this.versionFormRef.current);
        var id = (this.props.version.data.id) ? encodeURIComponent(this.props.version.data.id):null;
        saveItem("/web/softwareversions", id, data, this.props.onSaveResult);
    }


    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    { this.props.version.isNew ? (
                        <span>Add software version</span>
                    ) : (
                        <span>Edit software version</span>
                    ) }
                </DialogTitle>
                <DialogContent>
                    <div style={{ minWidth: 550 }}>
                        { this.props.version.error && (
                            <div>{this.props.version.error}</div>
                        )}
                        {this.renderBody()}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={12} style={{ padding: 20 }}>
                            {this.props.version.isNew ? (
                                <span/>
                            ):(
                                <StdButton label="Delete component" icon="delete" onClick={this.props.onDelete}/>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={12} style={{ padding: 20, textAlign: "right" }}>
                            <StdButton label="Cancel" type="alt" onClick={this.props.onClose}/>
                            <StdButton label="Save" onClick={this.handleSubmit}/>
                        </Grid>
                    </Grid>

                </DialogActions>
            </Dialog>

        )
    }

    renderBody(){
        if (this.props.version.error) {
            return <div>Error: {this.props.version.error.message}</div>;
        } else if (!this.props.version.isLoaded) {
            return <div className="text-center" ><div className="spinner-border m-5" /></div>;
        } else {
            var fieldErrors = (this.props.version.fieldErrors) ? this.props.version.fieldErrors:{};
            return (
                <form className="form-horizontal" ref={this.versionFormRef}>
                    { !this.props.version.isNew && (
                        <input name="id" type="hidden" className="form-control" defaultValue={this.state.version.id} onChange={this.changeData}/>
                    )}
                    <TextField
                        id="displayName" name="displayName" label="Display name" error={(fieldErrors['displayName']) ? true:false} helperText={fieldErrors['displayName']}
                        value={this.state.version.displayName} onChange={this.changeData}
                        margin="normal" variant="outlined" fullWidth />
                    <TextField
                        id="model" name="model" label="Model" error={(fieldErrors['model']) ? true:false} helperText={fieldErrors['model']}
                        value={this.state.version.model} onChange={this.changeData}
                        margin="normal" variant="outlined" fullWidth />
                    <TextField
                        id="version" name="version" label="Version" error={(fieldErrors['version']) ? true:false} helperText={fieldErrors['version']}
                        value={this.state.version.version} onChange={this.changeData}
                        margin="normal" variant="outlined" fullWidth />

                </form>
            );
        }
    }

}


export default VersionForm;